import { useRoutes } from "react-router-dom";
import { lazy } from "react";
import RouteList from "./RouteList";
import Cookies from "js-cookie";
import { isEmpty, redirectToSso } from "./helpers";
const Unauthorized = lazy(() => import("./pages/401"));
const Layout = lazy(() => import("./layouts"));
const AuthUser = lazy(() => import("./AuthUser"));

const Authenticated = ({ component }) => {
  const auth = Cookies.get("personalia_access_token");
  if (isEmpty(auth)) {
    redirectToSso();
    return;
  }

  return component;
};

const RedirectSso = () => {
  redirectToSso();
  return <></>;
};

export default function Router() {
  const routes = useRoutes([
    {
      path: "/",
      element: <Authenticated component={<Layout />} />,
      name: "Beranda",
      children: RouteList,
    },
    {
      path: "/auth",
      element: <AuthUser />,
      name: "Auth",
    },
    {
      path: "/401",
      name: "Unauthorized",
      element: <Unauthorized />,
    },
    {
      path: "login",
      element: <RedirectSso />,
    },
    {
      path: "*",
      element: <div>Not Found</div>,
    },
  ]);

  return routes;
}
